import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';
import { telegramActions } from '$store/telegram/index';
import { Api } from '$api';
import { batchActions } from '$store';
import router from '$navigation/router';
import { BOT } from '$shared/constants/pages';
import { ConnectChannelAction } from '$store/telegram/interface';
import { toastActions } from '$store/toast';
import { imActions } from '$store/im';

function* loadDashboardWorker() {
  try {
    const data = yield call(Api.get, '/telegram/dashboard');
    yield put(
      batchActions(
        batchActions(
          telegramActions.loadDashboardSuccess(data),
          telegramActions.setInviteLink(data.inviteLink),
          telegramActions.setConnectedChannel(data.channel),
        ),
      ),
    );
  } catch (e) {
    if (e.code === 'not_connected') {
      router.navigate(BOT);
    } else {
      yield put(telegramActions.loadDashboardFailed());
    }
  }
}

function* connectChannelWorker(action: ConnectChannelAction) {
  try {
    const data = yield call(Api.post, '/telegram/channel/connect', {
      channelId: action.payload,
    });
    yield put(
      batchActions(
        telegramActions.setInviteLink(data.inviteLink),
        telegramActions.setConnectedChannel(data.channel),
        imActions.setChooseChatTelegramSheetVisible(false),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* telegramSaga() {
  yield all([
    takeLatest(telegramActions.loadDashboard, loadDashboardWorker),
    takeLatest(telegramActions.connectChannel, connectChannelWorker),
  ]);
}
